export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13353.e718e8e9.jpg";